import { getSystemMessageDetail, getUserMessageDetail } from '@/apis/letter'
import useSWR from 'swr'
import { useRecoilValue } from 'recoil'
import { userState } from 'Store/user'

export function useLetterDetail(tab: 'System' | 'Personal', id: string) {
  const user = useRecoilValue(userState)
  const { data, mutate } = useSWR(
    user &&
      id !== '' &&
      (tab === 'System'
        ? `/system_message_notification/detail?id=${id}`
        : `/user_message_notification/detail?id=${id}`),
    () =>
      tab === 'System' ? getSystemMessageDetail(id) : getUserMessageDetail(id)
  )

  return { data, mutate }
}
